import axios from 'axios'
import { getEnv } from 'configurations'

const TYCHO_RPC_API = getEnv('REACT_APP_TYCHO_RPC_API')

const client = axios.create({
  baseURL: `${TYCHO_RPC_API}/`,
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default class RpcApiClient {
  static getDocuments(body) {
    return client.post('/api/get_documents', body)
  }

  static createDocument(document) {
    return client.post('/api/create_document', document)
  }

  static deleteDocument(document) {
    return client.post('/api/delete_document', document)
  }

  static getTags() {
    return client.post('/api/get_tags')
  }

  static getMaps() {
    return client.post('/api/get_maps')
  }

  static getUserMaps(token) {
    return client.post(
      '/api/get_user_maps',
      {},
      {
        headers: {
          Authorization: token,
        },
      },
    )
  }

  static getUsers() {
    return client.post('/api/get_users')
  }

  static getCompanies() {
    return client.post('/api/get_companies')
  }

  static updateUser(body) {
    return client.post('/api/update_user', body)
  }

  static getUserInfo(token) {
    return client.post(
      '/api/get_user_info',
      {},
      {
        headers: {
          Authorization: token,
        },
      },
    )
  }

  static updateUserInfo(token, body) {
    return client.post('/api/update_user_info', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static searchUnifilarData(token, body) {
    return client.post('/rpc/unifilar_data', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static async getPowerplants(token, body) {
    // const errorLayer={
    //     data:{
    //       body:{
    //         id:'powerplant_'+body.technology.toLowerCase(),
    //         layer:'powerplants',
    //         geotype:'icon',
    //         visible:false,
    //         data:[]
    //       }
    //     }
    //   }
    // let attempts=2
    // while (attempts > 0) {
    //   try{
    //     const response= await client.post('/powerplants', body, {
    //       headers: {
    //         Authorization: token,
    //       },
    //     })
    //   if(response.status >= 200 && response.status < 300){
    //     return response
    //   }else{
    //     throw new Error(`Respuesta no exitosa: ${response.status}`);
    //   }
    //   }catch(e){
    //     console.error(`Error: ${e.message}`);
    //     attempts--;
    //     if(attempts === 0)return errorLayer
    //     await new Promise(resolve => setTimeout(resolve, 1000));

    //   }
    // }

    //   return client.post('/ppowerplants', body, {
    //     headers: {
    //       Authorization: token,
    //     },
    //   }).catch(function (error) {
    //     const tempLayer={
    //       data:{
    //         body:{
    //           id:'powerplant_'+body.technology.toLowerCase(),
    //           layer:'powerplants',
    //           geotype:'icon',
    //           visible:false,
    //           data:[]
    //         }
    //       }
    //     }
    //     return tempLayer
    // })

    return client.post('/powerplants', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getTranline(token, body) {
    return client.post('/tranline', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static async getSubstations(token, body) {
    return client.post('/substations', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getInterconnection(token, body) {
    return client.post('/interconnection', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getArcheology(token, body) {
    return client.post('/archeology', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getIndigenousLanguages(token, body) {
    return client.post('/indigenous', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getTranlineInterconnection(token, body) {
    return client.post('/interconnection/line', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getMapbox(token, body) {
    return client.post('/mapbox/layers', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getDataStructure(token, body) {
    return client.post('/datastructure', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getMunicipality(token, body) {
    return client.post('/tools/municipality', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getOilPipes(token, body) {
    return client.post('/oil/gas/pipeline', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getOilBasin(token, body) {
    return client.post('/oil/gas/basin', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getWellSeep(token, url, body) {
    return client.post(`/oil/gas/${url}`, body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getRasters(token, data) {
    // console.log(data)
    try {
      if (data.type === 'point') {
        const speed = client.post(
          '/tools/raster/point',
          {
            lon: data.lon,
            lat: data.lat,
            basemap: data.bm,
            client: data.client,
            countries: data.country,
          },
          {
            headers: {
              Authorization: token,
            },
          },
        )
        // return speed.data.body.toFixed(2)
        // console.log(speed)
        return speed
      }
      if (data.type === 'polygon') {
        const geom = []
        data.polygonData.map((val) => {
          geom.push(val.toString().replace(',', ' '))
        })
        const speed = client.post(
          '/tools/raster/polygon',
          {
            geometry: geom.toString(),
            basemap: data.bm,
            client: data.client,
            countries: data.country,
          },
          {
            headers: {
              Authorization: token,
            },
          },
        )
        // console.log(speed)
        return speed
      }
      // console.log(speed.data.body)
    } catch (error) {
      console.log(error)
      return 'Not data available'
    }
  }

  static async downloadMail(token, dataClient, dataTycho) {
    // console.log(data)
    try {
      const cliente = await client.post('/download/client', dataClient, {
        headers: {
          Authorization: token,
        },
      })
      const tycho = await client.post('/download/tycho', dataTycho, {
        headers: {
          Authorization: token,
        },
      })
      return [cliente, tycho]
    } catch (error) {
      console.log(error)
      // return(false);
    }
  }

  static getSaaviLayers(token, body) {
    return client.post('/congestion/prices/polygon', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getSaaviLayersLMP(token, body) {
    return client.post('/congestion/prices/node', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getSaaviLayersCongestion(token, body) {
    return client.post('/congestion/prices', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getProjectsUnderDevelop(token, body) {
    return client.post('/proyects/under/develop', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getPowerplantsMarketInteligence(token, body) {
    return client.post('/market/intelligence/powerplants', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getSubstationsMarketInteligence(token, body) {
    return client.post('/market/intelligence/substations', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getTranlineMarketInteligence(token, body) {
    return client.post('/market/intelligence/tranline', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getFiles(token, body) {
    return client.post('/geocreator/file_menu', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getFileTree(token, body) {
    return client.post('/geocreator/file_tree', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getFileContent(token, body) {
    return client.post('/geocreator/file_content', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static uploadFiles(token, body) {
    return client.post('/geocreator/request_signed_url', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static getUserList(token, body) {
    return client.post('/api/get_users_list', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  static createDocumentGeocreator(token, document) {
    return client.post('/geocreator/create_document', document, {
      headers: {
        Authorization: token,
      },
    })
  }

  static deleteGeocreatorFile(token, document) {
    return client.post('/geocreator/delete_document', document, {
      headers: {
        Authorization: token,
      },
    })
  }

  static lockFiles(token, body) {
    return client.post('/geocreator/lock_files', body, {
      headers: {
        Authorization: token,
      },
    })
  }

  // static updateLock(token, body) {
  //     return client.post('/api/update_lock', body, {
  //       headers: {
  //         Authorization: token,
  //       },
  //     })
  //   }

  static unlockFiles(token, body) {
    // const id=56
    return navigator.sendBeacon('/geocreator/lock_files', body, {
      headers: {
        Authorization: token,
      },
    })
  }
}
